import * as React from "react";
import type { SVGProps } from "react";
const SvgLineDottedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="line_dotted_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M289.579 397.568a86.825 86.825 0 0 1 18.56-28.075L540.672 133.12c58.197-59.093 154.667-67.499 219.136-1.963a161.536 161.536 0 0 1 0 225.835l-.128.128-232.533 235.392c-9.131 9.173-20.054 16.17-32.171 20.48l-162.048 58.155a85.163 85.163 0 0 1-91.307-22.443 88.576 88.576 0 0 1-16.81-93.867l64.768-157.226zm79.445 33.792-19.925 48.341-44.8 108.886 109.525-39.254 52.48-18.858 232.619-235.35a72.96 72.96 0 0 0 0-102.058c-27.734-28.16-69.547-26.24-97.28 1.962L369.024 431.403zM128 768a42.667 42.667 0 1 0 0 85.333h85.333a42.667 42.667 0 1 0 0-85.333H128zm213.333 0a42.667 42.667 0 1 0 0 85.333h85.334a42.667 42.667 0 1 0 0-85.333h-85.334zM512 810.667A42.667 42.667 0 0 1 554.667 768H640a42.667 42.667 0 1 1 0 85.333h-85.333A42.667 42.667 0 0 1 512 810.667zM768 768a42.667 42.667 0 1 0 0 85.333h85.333a42.667 42.667 0 1 0 0-85.333H768z"
    />
  </svg>
);
export default SvgLineDottedIcon;
